import { render, staticRenderFns } from "./HppAdjDetails_Total.vue?vue&type=template&id=18d3f30e&"
import script from "./HppAdjDetails_Total.vue?vue&type=script&lang=js&"
export * from "./HppAdjDetails_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports